import React, { Component } from "react";
import MessagesList from "./messages/messagesList.jsx";
import MessagesInput from "./messages/messagesInput.jsx";
import Footer from "./Footer";
import MessagesStyles from "./messages.module.css";

class Messages extends Component {
  state = {
    talkingTo: "Jeremy",
    conversation: [
      {
        id: 0,
        author: "talkingTo",
        time: "15:30",
        message: "Hey, ho!",
      },
    ],
    currentMessage: "",
    isEnabled: true,
  };

  getTime() {
    const timeNow = new Date();
    const getAndFormatMinutes = () =>
      timeNow.getMinutes() < 10
        ? `0${timeNow.getMinutes()}`
        : timeNow.getMinutes();
    return `${timeNow.getHours()}:${getAndFormatMinutes()}`;
  }

  handleClick = (e) => {
    e.preventDefault();
    if (this.state.currentMessage) {
      const conversation = this.state.conversation;
      const newMessage = {
        id: this.state.conversation.length,
        author: "me",
        time: this.getTime(),
        message: this.state.currentMessage,
      };
      this.setState({ conversation: [...conversation, newMessage] });
      setTimeout(() => {
        this.setState({ currentMessage: "" });
        this.state.conversation.length > 5 && this.sendEndMessage();
      }, 200);
    }
  };

  handleChange = (e) => {
    e.preventDefault();
    this.setState({ currentMessage: e.target.value });
  };

  sendEndMessage = () => {
    this.setState({ isEnabled: false });
    const conversation = this.state.conversation;
    const newMessage = {
      id: this.state.conversation.length,
      author: "talkingTo",
      time: this.getTime(),
      message: "End of the demo. Thanks for testing!",
    };
    this.setState({ conversation: [...conversation, newMessage] });
  };

  render() {
    const {
      conversation: data,
      talkingTo,
      currentMessage,
      isEnabled,
    } = this.state;
    return (
      <div className={MessagesStyles.main}>
        <div className={MessagesStyles.container}>
          <div className={MessagesStyles.author}>{talkingTo}</div>
          <MessagesList data={data} />
          <MessagesInput
            value={currentMessage}
            onChange={this.handleChange}
            onClick={this.handleClick}
            disabled={!isEnabled}
          />
          <Footer />
        </div>
      </div>
    );
  }
}

export default Messages;
